/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, March 4th 2022, 1:49:12 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import "theme/css/WorkflowBuilder.css";
import { WorkflowBuilder } from "service-builder/components/workflow-builder/WorkflowBuilder";
import { useServiceBuilderContext } from "service-builder/providers";

export const BPMNWorkflowConfigurationPage = () => {
  const { processDefinitionContext } = useServiceBuilderContext();
  const { currentProcessDefinition } = processDefinitionContext;
  return <WorkflowBuilder processDefinition={currentProcessDefinition} />;
};
